import axios from 'axios';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setNearbyAirports as updateNearbyAirports } from '../../features/mainFilter/mainFilterSlice';
import { selectFiltersLoaded } from '../../features/mainFilter/selectors';
import { getParamFromUrl } from '../../utilities/urlResolver';
import { LOCALE } from '../../constants';

export default function useGetNearbyAirports() {
  const filtersReady = useSelector(selectFiltersLoaded)
  const [nearbyAirports, setNearbyAirports] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (window.holidayFinder.market === 4 || !filtersReady) return;

    const selectedFromwhere = JSON.parse(localStorage.getItem('selectedFromwhere'));
    if (!selectedFromwhere && !(getParamFromUrl('pr_fromwhere') || getParamFromUrl('fromwhere'))) {
      const getNearbyAirport = async () => {
        const request = axios.get(`/api_no_auth/holiday_finder/deal-search-engine-default-origin-airport/?data={%22locale%22:%22${LOCALE}%22,%22market%22:${window.holidayFinder.market}}&t=${Date.now()}`);
        const response = await request;
        setNearbyAirports(response.data?.data);
      }

      getNearbyAirport()
    };
  }, [filtersReady]);

  useEffect(() => {
    const airports = Array.isArray(nearbyAirports) ? nearbyAirports : [nearbyAirports];
    if (filtersReady && nearbyAirports) {
      dispatch(updateNearbyAirports(airports))
    }
  }, [filtersReady, dispatch, nearbyAirports])
}
